import { API } from './resources'

export default {
  getFromJudgesProjects: (templateIDs, limit, offset, sort, filter, exclude, showHidden, type) => {
    return API.get('/judging/registration_projects', { params: { templateIDs, limit, offset, sort, filter, exclude, showHidden, type } })
  },
  getPollByProjectId: (projectIDs) => {
    return API.get(`/poll/project?projectIDs=${projectIDs.join(',')}`)
  },
  getJudgingTeams: (projectIDs) => {
    return API.get('/judging/teams', { params: { projectIDs } })
  },
  downloadJudgingRubric: (projectID) => {
    return API.get(`/judging/rubric/${projectID}`, { responseType: 'blob' })
  },
  uploadJudgingRubric: (projectID, rubricFile) => {
    return API.post(`/judging/rubric/${projectID}`, rubricFile, { headers: { 'Content-Type': 'multipart/form-data' } })
  },
  getJudgingRubric: (projectID) => {
    return API.get(`/projects/${projectID}/judgePairings`)
  },
  submitRubricScore: (projectID) => {
    return API.post(`/judging/rubric/${projectID}/submit`)
  },
  getJudgingTeamGroups: () => {
    return API.get('/judging/teamGroups')
  },
  generateJudgingTeams: ({ teamSize, templateIds, teamTemplateId, filterOptions, diversifiedQuestionIds }) => {
    return API.post('/judging/generateTeams', { teamSize, templateIds, teamTemplateId, filterOptions, diversifiedQuestionIds })
  },
  switchTeams: ({ userName, fromTeam, toTeam }) => {
    return API.post('/judging/switchTeam', { userName, fromTeam, toTeam })
  },
  setTeamLead: ({ userName, teamID }) => {
    return API.post('/judging/setTeamLead', { userName, teamID })
  },
  removeTeamLead: ({ userName, teamID }) => {
    return API.post('/judging/removeTeamLead', { userName, teamID })
  },
  removeUserFromTeam: ({ userName, teamID }) => {
    return API.post('/judging/removeUserFromTeam', { userName, teamID })
  },
  addUserToTeam: ({ userName, teamID }) => {
    return API.post('/judging/addUserToTeam', { userName, teamID })
  },
  getJudgingReport: () => {
    return API.get('/judging/getReport')
  },
  setJudgingTeamLockStatus: function ({ userName, teamID }) {
    return API.get('/judging/setTeamLock', { userName, teamID })
  },
  scheduleJudgingMeetings: function ({ teamID, startDatetime, duration }) {
    return API.post('/judging/schedule', { teamID, startDatetime, duration })
  },
  getJudgingGroupsForProject: function (projectID) {
    return API.get(`judging/team/${projectID}/subgroups`)
  },
  updateUserJudgeGroup: function (topic, userName, projectID) {
    return API.put(`judging/team/${projectID}/user/${userName}/changesubgroup`, { topic })
  }
}
